import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import PurchaseOrderDetail from "../purchase-orders/detail";
import PurchaseOrdersOverview from "../purchase-orders/purchase-orders";
import ProductDrafts from "./product-drafts";
import Suppliers from "./suppliers";
import PurchaseOrderShipmentsList from "./purchase-order-shipments";
import PurchaseOrderShipmentDetail from "./purchase-order-shipments/detail";
import PurchaseOrderInvoicesList from "./purchase-order-invoices";
import StockOverview from "./stock-overview";

const PARENT_URL = "/cms/orders";

const PurchaseOrders = () => {
  return (
    <Routes>
      <Route path={`/all`} element={<PurchaseOrdersOverview />} />
      <Route path={`all/:id`} element={<PurchaseOrderDetail />} />
      <Route path={`/product-drafts`} element={<ProductDrafts />} />
      <Route path={`/suppliers`} element={<Suppliers />} />
      <Route path={`/shipments`} element={<PurchaseOrderShipmentsList />} />
      <Route path={`/shipments/:id`} element={<PurchaseOrderShipmentDetail />} />
      <Route path={`/invoices`} element={<PurchaseOrderInvoicesList />} />
      <Route path={`/stock`} element={<StockOverview />} />
      <Route path={``} element={<Navigate to={`${PARENT_URL}/all`} replace />} />
    </Routes>
  );
};

export default PurchaseOrders;
